import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate, VersionEvent, VersionReadyEvent } from '@angular/service-worker';
import { filter, first, takeWhile, tap } from 'rxjs/operators';
import { concat, interval, Observable, Subscription } from 'rxjs';
import { WindowService } from 'src/app/core/services/global';
import { ConfigService } from '../../../core/services';

@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  constructor(
    private appRef: ApplicationRef,
    private updates: SwUpdate,
    private windowService: WindowService,
    private configService: ConfigService,
  ) {}

  private available$: Subscription;
  private everyHourOnceAppIsStable$: Observable<number | boolean> | Subscription;

  check(): void {
    if (this.configService.isProduction) {
      this.checkOnAvailable();
      this.startIntervalForChecking();
    }
  }

  unsubscribe(): void {
    if (this.configService.isProduction) {
      if (this.available$ && this.available$.unsubscribe) {
        this.available$.unsubscribe();
      }

      if (
        this.everyHourOnceAppIsStable$ &&
        (this.everyHourOnceAppIsStable$ as Subscription).unsubscribe
      ) {
        (this.everyHourOnceAppIsStable$ as Subscription).unsubscribe();
      }
    }
  }

  private checkOnAvailable(): void {
    this.available$ = this.updates.versionUpdates
      .pipe(
        tap((event: VersionEvent) => {
          console.log('Version check event: ', event);
        }),
        filter((event: VersionEvent): event is VersionReadyEvent => event.type === 'VERSION_READY'),
        takeWhile(() => this.updates.isEnabled),
      )
      .subscribe((event: VersionEvent) => {
        console.log('New version is available, Version check event: ', event);
        this.windowService.locationReload();
      });
  }

  private startIntervalForChecking(): void {
    const appIsStable$: Observable<boolean> = this.appRef.isStable.pipe(
      first((isStable) => isStable === true),
    );
    const everyHour$: Observable<number> = interval(60 * 60 * 1000);
    this.everyHourOnceAppIsStable$ = concat(appIsStable$, everyHour$);

    this.everyHourOnceAppIsStable$.subscribe((value: any) => {
      this.updates
        .checkForUpdate()
        .then((resolved: boolean) => {
          console.log('checkForUpdate resolved: ', resolved);
        })
        .catch((error: any) => {
          console.log('checkForUpdate failed: ', error);
        });
    });
  }
}
